import type { ApolloError } from '@apollo/client/errors';

const DEFAULT =
  '予期せぬエラーが発生しました。しばらく経ってからもう一度お試しください。';

const API_ERRORS = {
  _global: {
    DEFAULT:
      '予期せぬエラーが発生しました。しばらく経ってからもう一度お試しください。',
    MISSING_REQUIRED_SCOPE: 'このアカウントでは利用できない機能です。',
  },
  createUserAndVideoAccount: {
    DEFAULT: 'アカウントが登録できませんでした。',
    // https://wiki.unext-info.jp/pages/viewpage.action?pageId=90148540
    ESCOTT_TOKEN_ERROR: 'このクレジットカードは利用できません。',
    FREE_RIDE_INVALID: 'このクレジットカードは利用できません。',
    INVALID_CREDIT_CARD: 'このクレジットカードは利用できません。',
    APPLICATION_SUBMISSION_ERROR: '登録できませんでした。',
  },
  sendEmailVerificationCode: {
    DEFAULT: 'メールが送信できませんでした。',
    BAD_USER_INPUT: 'メールアドレスの形式が正しくありません。',
    DUPLICATE_EMAIL_ADDRESS: 'メールアドレスは既に登録されています。',
  },
  validateEmailVerificationCode: {
    DEFAULT: '認証コードが確認できません。最初からお試しください。',
    DUPLICATE_EMAIL_ADDRESS: 'メールアドレスは既に登録されています。',
    INVALID_AUTH_CODE: '本人確認コードが間違っています。',
    AUTH_CODE_EXPIRED: '有効期限が過ぎています。最初からお試しください。',
  },
  createUser: {
    DEFAULT: 'アカウントが登録できませんでした。',
  },
  updateUserInfo: {
    DEFAULT: '変更できませんでした。',
  },
  issueInvoiceMutation: {
    DEFAULT: '作成出来ませんでした。',
  },
  createSbpsV2BillingMethodRegistration: {
    DEFAULT: '予期せぬエラーが発生しました。',
  },
  sendCustomerInquiryV2: {
    DEFAULT: '予期せぬエラーが発生しました。',
  },
};

type ApiErrorKeys = keyof typeof API_ERRORS;

function getGraphqlErrorCode(error: ApolloError): string {
  return error.graphQLErrors?.[0]?.extensions?.code
    ? (error.graphQLErrors?.[0]?.extensions?.code as string)
    : '';
}

function isApolloError(error: unknown): error is ApolloError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'graphQLErrors' in error &&
    'networkError' in error
  );
}

export const errorMessagesHelper = {
  unexpected: () => DEFAULT,

  getGraphqlErrorCode,

  graphql: (error: unknown, mutation?: ApiErrorKeys): string => {
    // ApolloErrorでない場合はデフォルトエラーメッセージを返す
    if (!isApolloError(error)) {
      return DEFAULT;
    }

    const errorCode = getGraphqlErrorCode(error);

    if (!mutation) {
      const errorMessage =
        API_ERRORS._global[errorCode as keyof typeof API_ERRORS._global] ??
        API_ERRORS._global.DEFAULT;
      return `${errorMessage}${errorCode && ` (${errorCode})`}`;
    }

    const errorList = API_ERRORS[mutation];
    const errorMessage =
      errorList[errorCode as keyof typeof errorList] ?? errorList['DEFAULT'];

    return `${errorMessage}${errorCode && ` (${errorCode})`}`;
  },
};
